<ng-container
    *ngIf="authService.isLoggedOut()"
>
  <div class="wrapper">
    <div class="card">
      <div class="card-body">
        <p
            class="card-title font-weight-bold"
            id="title"
        >
          Login
        </p>
        <p
            class="card-subtitle text-muted"
            id="subtitle"
        >
          Geben Sie die 4-stellige PIN ein, um das Datenbank-Managment-System zu betreten.
        </p>
      </div>
    </div>

    <form>
      <div
          class="form-group"
          id="textfield"
      >
        <input
            type="password"
            class="form-control form-control-sm"
            id="pin"
            placeholder="0000"
            [(ngModel)]="pin"
            name="pin"
            size="4"
            autofocus
            [disabled]="authService.locked"
        >
      </div>
      <button
          type="submit"
          class="btn btn-sm"
          id="loginButton"
          (click)="login()"
          [disabled]="authService.locked"
      >
        <fa-icon [icon]="faArrowCircleRight"></fa-icon>
      </button>

      <p class="supportlink">
        <a
            href="javascript:"
            (click)="supportService.showSupportWindow()"
        >
          Support
        </a>
      </p>
    </form>

    <ng-container *ngIf="authService.message != null">
      <div>
        <span class="text-muted">{{authService.message}}</span>
      </div>
    </ng-container>
  </div>
</ng-container>
